import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './TypingText.css';

const TypingText = ({
  texts,
  typingSpeed = 70,
  deletingSpeed = 35,
  pauseDuration = 2200,
}) => {
  const [displayText, setDisplayText] = useState('');
  const [textIndex, setTextIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentText = texts[textIndex % texts.length];

    const timeout = setTimeout(
      () => {
        if (!isDeleting) {
          const next = currentText.substring(0, displayText.length + 1);
          setDisplayText(next);

          if (next === currentText) {
            setTimeout(() => setIsDeleting(true), pauseDuration);
          }
        } else {
          const next = currentText.substring(0, displayText.length - 1);
          setDisplayText(next);

          if (next === '') {
            setIsDeleting(false);
            setTextIndex((prev) => (prev + 1) % texts.length);
          }
        }
      },
      isDeleting ? deletingSpeed : typingSpeed
    );

    return () => clearTimeout(timeout);
  }, [
    displayText,
    isDeleting,
    textIndex,
    texts,
    typingSpeed,
    deletingSpeed,
    pauseDuration,
  ]);

  return (
    <span className='typing-text'>
      {displayText}
      <span className='typing-text__cursor' aria-hidden='true'>
        |
      </span>
    </span>
  );
};

TypingText.propTypes = {
  texts: PropTypes.arrayOf(PropTypes.string).isRequired,
  typingSpeed: PropTypes.number,
  deletingSpeed: PropTypes.number,
  pauseDuration: PropTypes.number,
};

export default TypingText;
